module.exports = __webpack_public_path__ + "fonts/montserrat-semibolditalic-webfont.d937ed3.woff2";